import {Session} from '../Session';
import {DateTimeCurrentFactory} from 'md-library-test-first-version';
import {Injectable} from '@angular/core';

@Injectable()
export class Factory {

    private dateTimeCurrentFactory: DateTimeCurrentFactory = null;

    // ########################################

    constructor(
        dateTimeCurrentFactory: DateTimeCurrentFactory
    ) {
        this.dateTimeCurrentFactory = dateTimeCurrentFactory;
    }

    // ########################################

    public create(): Session {
        const storage = window.sessionStorage;

        return new Session(
            storage,
            this.dateTimeCurrentFactory
        );
    }

    // ########################################
}
